import React, { Component } from "react";

// CSS
import "../../styles/newDesign.scss";
import "./Resources.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { apiFetch, resolveTenant } from "../../Helper/Api";

// Properties
const properties = require("../../properties.json");

// Fixed sections, matching ResourceCategory on the backend -- order here is display order.
const CATEGORIES = [
  { key: "DOWNLOAD", title: "Free Downloads", icon: "📎", linkLabel: "Download" },
  { key: "TUTORIAL", title: "Tutorials", icon: "▶", linkLabel: "Watch" },
  { key: "ARTICLE", title: "Articles", icon: "📄", linkLabel: "Read" },
];

class Resources extends Component {
  state = {
    tenant: null,
    notFound: false,
    items: [],
    loading: true,
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => {
        document.title = tenant.name ? `Resources | ${tenant.name}` : properties.site_name;
        this.setState({ tenant });
        return apiFetch("/resources", { query: { branchId: tenant.branchId } });
      })
      .then((items) => this.setState({ items: items || [], loading: false }))
      .catch(() => this.setState({ notFound: true, loading: false }));
  }

  render() {
    const { tenant, notFound, items, loading } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }

    if (!tenant) return null;

    const hasAny = items.length > 0;

    return (
      <>
        <Header tenant={tenant} />

        <div className="nd-page">
          <div className="nd-hero">
            <div className="nd-wrap">
              <div className="nd-eyebrow">Resources</div>
              <h1>Free Tools &amp; Reading</h1>
              <p>Downloadable files, tutorials and articles to support your learning journey.</p>
            </div>
          </div>

          <div className="nd-section nd-wrap">
            {!loading && !hasAny ? (
              <p style={{ color: "var(--nd-muted)" }}>No resources added yet.</p>
            ) : (
              CATEGORIES.map((cat) => {
                const catItems = items.filter((it) => it.category === cat.key);
                if (catItems.length === 0) return null;
                return (
                  <div className="res-cat" key={cat.key}>
                    <h2>{cat.title}</h2>
                    <div className="res-grid">
                      {catItems.map((item) => (
                        <div className="res-card" key={item.id}>
                          <div className="res-icon">{cat.icon}</div>
                          <h3>{item.title}</h3>
                          {item.description && <p>{item.description}</p>}
                          <a className="res-link" href={item.linkUrl} target="_blank" rel="noopener noreferrer">
                            {cat.linkLabel} →
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default Resources;
